import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import ADD_WAREHOUSE_RELEASE from 'api/mutations/ADD_WAREHOUSE_RELEASE';
import DUPLICATE_WAREHOUSE_RELEASE from 'api/mutations/DUPLICATE_WAREHOUSE_RELEASE';
import UPDATE_WAREHOUSE_RELEASE_APPROVE from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_APPROVE';
import UPDATE_WAREHOUSE_RELEASE_CANCEL from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_CANCEL';
import UPDATE_WAREHOUSE_RELEASE_COMPLETE from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_COMPLETE';
import REMOVE_WAREHOUSE_RELEASE from 'api/mutations/REMOVE_WAREHOUSE_RELEASE';
import GET_WAREHOUSE_RELEASE from 'api/queries/GET_WAREHOUSE_RELEASE';
import { toast } from 'components/common/Toast/Toast';
import { useHistory } from 'react-router';
export default function useWarehouseReleases() {
    const { t } = useTranslation('warehouseReleases');
    const history = useHistory();
    const [addWarehouseRelaseMutation] = useMutation(ADD_WAREHOUSE_RELEASE, { refetchQueries: ['GetWarehouseReleases'] });
    const [duplicateWarehouseRelaseMutation] = useMutation(DUPLICATE_WAREHOUSE_RELEASE, { refetchQueries: ['GetWarehouseReleases'] });
    const [updateWarehouseRelaseApproveMutation] = useMutation(UPDATE_WAREHOUSE_RELEASE_APPROVE, { refetchQueries: ['GetWarehouseReleases'] });
    const [updateWarehouseRelaseCancelMutation] = useMutation(UPDATE_WAREHOUSE_RELEASE_CANCEL, { refetchQueries: ['GetWarehouseReleases'] });
    const [updateWarehouseRelaseCompleteMutation] = useMutation(UPDATE_WAREHOUSE_RELEASE_COMPLETE, { refetchQueries: ['GetWarehouseReleases'] });
    const [removeWarehouseRelaseMutation] = useMutation(REMOVE_WAREHOUSE_RELEASE, { refetchQueries: ['GetWarehouseReleases'] });
    const addWarehouseRelase = useCallback(() => {
        return addWarehouseRelaseMutation().then((response) => {
            var _a, _b, _c;
            const warehouseReleaseNodeId = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.addWarehouseRelease) === null || _b === void 0 ? void 0 : _b.warehouseRelease) === null || _c === void 0 ? void 0 : _c.id;
            history.replace(`/warehouse-releases/${warehouseReleaseNodeId}/specifications`);
        });
    }, []);
    const removeWarehouseRelase = useCallback((warehouseReleaseNodeId) => {
        return removeWarehouseRelaseMutation({ variables: { warehouseReleaseNodeId: warehouseReleaseNodeId } }).then(() => {
            toast('success', t('warehouse_release_removed'));
        });
    }, []);
    const duplicateWarehouseRelase = useCallback((warehouseReleaseNodeId) => {
        return duplicateWarehouseRelaseMutation({ variables: { warehouseReleaseNodeId } }).then(() => {
            toast('success', t('warehouse_release_duplicated'));
        });
    }, []);
    const updateWarehouseRelaseApprove = useCallback((warehouseReleaseNodeId) => {
        return updateWarehouseRelaseApproveMutation({ variables: { warehouseReleaseNodeId }, refetchQueries: [
                { query: GET_WAREHOUSE_RELEASE, variables: { id: warehouseReleaseNodeId } },
            ] }).then(() => {
            toast('success', t('warehouse_release_approved'));
        });
    }, []);
    const updateWarehouseRelaseCancel = useCallback((warehouseReleaseNodeId) => {
        return updateWarehouseRelaseCancelMutation({ variables: { warehouseReleaseNodeId }, refetchQueries: [
                { query: GET_WAREHOUSE_RELEASE, variables: { id: warehouseReleaseNodeId } },
            ] }).then(() => {
            toast('success', t('warehouse_release_cancelled'));
        });
    }, []);
    const updateWarehouseRelaseComplete = useCallback((warehouseReleaseNodeId) => {
        return updateWarehouseRelaseCompleteMutation({ variables: { warehouseReleaseNodeId }, refetchQueries: [
                { query: GET_WAREHOUSE_RELEASE, variables: { id: warehouseReleaseNodeId } },
            ] }).then(() => {
            toast('success', t('warehouse_release_completed'));
        });
    }, []);
    return { addWarehouseRelase, duplicateWarehouseRelase, removeWarehouseRelase, updateWarehouseRelaseApprove, updateWarehouseRelaseCancel, updateWarehouseRelaseComplete };
}
